export default {
  pt: {
    'advertencias.title': 'Gestões',
    'advertencias.eyebrow': 'Gestão de consequências',
    'advertencias.hint': 'Infrações classificadas como Gestão na Conferência de Diárias e no Relatório de Infrações da Jornada. Escolha o colaborador, selecione as ocorrências pendentes e gere a gestão, que passa para Gestões Pendentes.',
    'advertencias.de': 'De',
    'advertencias.ate': 'Até',
    'advertencias.filtro.colaborador': 'Colaborador',
    'advertencias.filtro.base': 'Base',
    'advertencias.filtro.origem': 'Origem da gestão',
    'advertencias.filtro.todos': 'Todas',
    'advertencias.origem.diaria': 'Diária',
    'advertencias.origem.jornada': 'Jornada',
    'advertencias.kpi.total': 'Gestões',
    'advertencias.kpi.totalHint': 'ocorrências classificadas como gestão no período',
    'advertencias.kpi.colaboradores': 'Colaboradores',
    'advertencias.kpi.colaboradoresHint': 'com ao menos uma ocorrência no período',
    'advertencias.kpi.diaria': 'Da diária',
    'advertencias.kpi.diariaHint': 'marcadas no Painel de Conferência',
    'advertencias.kpi.jornada': 'Da jornada',
    'advertencias.kpi.jornadaHint': 'marcadas no Relatório de Infrações',
    'advertencias.lista.titulo': 'Pendentes por colaborador',
    'advertencias.lista.vazio': 'Nenhuma ocorrência pendente com os filtros atuais.',
    'advertencias.lista.pendentes_one': '{{count}} pendente',
    'advertencias.lista.pendentes_other': '{{count}} pendentes',
    'advertencias.ocorrencias.titulo': 'Ocorrências',
    'advertencias.ocorrencias.escolha': 'Escolha um colaborador na lista ao lado.',
    'advertencias.ocorrencias.vazio': 'Nenhuma ocorrência pendente para este colaborador.',
    'advertencias.col.data': 'Data',
    'advertencias.col.dia': 'Dia',
    'advertencias.col.origem': 'Origem',
    'advertencias.col.ocorrencia': 'Ocorrência',
    'advertencias.col.detalhe': 'Detalhe',
    'advertencias.col.registro': 'Registrado por',
    'advertencias.selecionadas': '{{n}} de {{total}} marcadas',
    'advertencias.gerarDica': 'Vincula as ocorrências selecionadas a uma gestão pendente, com código único e histórico.',
    'advertencias.detalhe.jornada': 'jornada de {{jornada}}',
    'advertencias.detalhe.limite': 'limite de {{limite}}',
    'advertencias.detalhe.lancado': 'lançado {{status}}',
    'advertencias.detalhe.previsto': 'apurado {{previsao}}',
    'advertencias.detalhe.km': '{{km}} entre abertura e encerramento',
    'advertencias.detalhe.antecedencia': '{{tempo}} antes do horário programado',
    'advertencias.detalhe.kmAteProgramado': '{{km}} rodados até o horário programado',
    'advertencias.detalhe.tpi': 'TPI {{tempo}}',
    'advertencias.detalhe.tpf': 'TPF {{tempo}}',
    'advertencias.detalhe.semRastreador': 'sem garantia do rastreador',
    'advertencias.filtro.ocorrencia': 'Ocorrência',
    'advertencias.filtro.funcao': 'Função',
    'advertencias.col.inicio': 'Data e hora início',
    'advertencias.col.fim': 'Data e hora fim',
    'advertencias.col.tempoTotal': 'Tempo total da jornada',
    'advertencias.col.horasIndevidas': 'Horas Indevidas',
    'advertencias.horasIndevidas.incluir': 'Adicionar a Horas Indevidas',
    'advertencias.horasIndevidas.adicionada': 'Adicionada',
    'advertencias.horasIndevidas.adicionadaPor': 'Adicionada a Horas Indevidas por {{quem}} em {{quando}}',
    'advertencias.horasIndevidas.automatica': 'Já está em Horas Indevidas',
    'advertencias.horasIndevidas.semJornada': 'Sem início e fim de jornada, não há batida a alterar',
  },
  en: {
    'advertencias.title': 'Measures',
    'advertencias.eyebrow': 'Consequence management',
    'advertencias.hint': 'Violations classified as a measure in the allowance check and in the journey violation report. Select an employee, choose the pending occurrences and create the measure, which moves to Pending measures.',
    'advertencias.de': 'From',
    'advertencias.ate': 'To',
    'advertencias.filtro.colaborador': 'Employee',
    'advertencias.filtro.base': 'Base',
    'advertencias.filtro.origem': 'Measure source',
    'advertencias.filtro.todos': 'All',
    'advertencias.origem.diaria': 'Allowance',
    'advertencias.origem.jornada': 'Journey',
    'advertencias.kpi.total': 'Measures',
    'advertencias.kpi.totalHint': 'occurrences classified as a measure in the period',
    'advertencias.kpi.colaboradores': 'Employees',
    'advertencias.kpi.colaboradoresHint': 'with at least one occurrence in the period',
    'advertencias.kpi.diaria': 'From allowances',
    'advertencias.kpi.diariaHint': 'marked in the Check panel',
    'advertencias.kpi.jornada': 'From journeys',
    'advertencias.kpi.jornadaHint': 'marked in the Violations report',
    'advertencias.lista.titulo': 'Pending by employee',
    'advertencias.lista.vazio': 'No pending occurrences for the current filters.',
    'advertencias.lista.pendentes_one': '{{count}} pending',
    'advertencias.lista.pendentes_other': '{{count}} pending',
    'advertencias.ocorrencias.titulo': 'Occurrences',
    'advertencias.ocorrencias.escolha': 'Pick an employee in the list.',
    'advertencias.ocorrencias.vazio': 'No pending occurrences for this employee.',
    'advertencias.col.data': 'Date',
    'advertencias.col.dia': 'Weekday',
    'advertencias.col.origem': 'Source',
    'advertencias.col.ocorrencia': 'Occurrence',
    'advertencias.col.detalhe': 'Detail',
    'advertencias.col.registro': 'Recorded by',
    'advertencias.selecionadas': '{{n}} of {{total}} ticked',
    'advertencias.gerarDica': 'Links the selected occurrences to a pending measure with a unique code and history.',
    'advertencias.detalhe.jornada': 'shift of {{jornada}}',
    'advertencias.detalhe.limite': 'limit of {{limite}}',
    'advertencias.detalhe.lancado': 'entered {{status}}',
    'advertencias.detalhe.previsto': 'measured {{previsao}}',
    'advertencias.detalhe.km': '{{km}} between opening and closing',
    'advertencias.detalhe.antecedencia': '{{tempo}} before the scheduled time',
    'advertencias.detalhe.kmAteProgramado': '{{km}} driven until the scheduled time',
    'advertencias.detalhe.tpi': 'SToS {{tempo}}',
    'advertencias.detalhe.tpf': 'SToE {{tempo}}',
    'advertencias.detalhe.semRastreador': 'not confirmed by the tracker',
    'advertencias.filtro.ocorrencia': 'Occurrence',
    'advertencias.filtro.funcao': 'Role',
    'advertencias.col.inicio': 'Start date and time',
    'advertencias.col.fim': 'End date and time',
    'advertencias.col.tempoTotal': 'Total shift time',
    'advertencias.col.horasIndevidas': 'Undue Hours',
    'advertencias.horasIndevidas.incluir': 'Add to Undue Hours',
    'advertencias.horasIndevidas.adicionada': 'Added',
    'advertencias.horasIndevidas.adicionadaPor': 'Added to Undue Hours by {{quem}} on {{quando}}',
    'advertencias.horasIndevidas.automatica': 'Already in Undue Hours',
    'advertencias.horasIndevidas.semJornada': 'Without shift start and end there is no punch to change',
  },
  es: {
    'advertencias.title': 'Gestiones',
    'advertencias.eyebrow': 'Gestión de consecuencias',
    'advertencias.hint': 'Infracciones clasificadas como gestión en la verificación de viáticos y en el informe de infracciones de jornada. Elija el colaborador, seleccione las ocurrencias pendientes y genere la gestión, que pasa a Gestiones pendientes.',
    'advertencias.de': 'Desde',
    'advertencias.ate': 'Hasta',
    'advertencias.filtro.colaborador': 'Colaborador',
    'advertencias.filtro.base': 'Base',
    'advertencias.filtro.origem': 'Origen de la gestión',
    'advertencias.filtro.todos': 'Todas',
    'advertencias.origem.diaria': 'Viático',
    'advertencias.origem.jornada': 'Jornada',
    'advertencias.kpi.total': 'Gestiones',
    'advertencias.kpi.totalHint': 'ocurrencias clasificadas como gestión en el período',
    'advertencias.kpi.colaboradores': 'Colaboradores',
    'advertencias.kpi.colaboradoresHint': 'con al menos una ocurrencia en el período',
    'advertencias.kpi.diaria': 'De viáticos',
    'advertencias.kpi.diariaHint': 'marcadas en el Panel de Verificación',
    'advertencias.kpi.jornada': 'De jornada',
    'advertencias.kpi.jornadaHint': 'marcadas en el Informe de Infracciones',
    'advertencias.lista.titulo': 'Pendientes por colaborador',
    'advertencias.lista.vazio': 'Ninguna ocurrencia pendiente con los filtros actuales.',
    'advertencias.lista.pendentes_one': '{{count}} pendiente',
    'advertencias.lista.pendentes_other': '{{count}} pendientes',
    'advertencias.ocorrencias.titulo': 'Ocurrencias',
    'advertencias.ocorrencias.escolha': 'Elija un colaborador en la lista.',
    'advertencias.ocorrencias.vazio': 'Ninguna ocurrencia pendiente para este colaborador.',
    'advertencias.col.data': 'Fecha',
    'advertencias.col.dia': 'Día',
    'advertencias.col.origem': 'Origen',
    'advertencias.col.ocorrencia': 'Ocurrencia',
    'advertencias.col.detalhe': 'Detalle',
    'advertencias.col.registro': 'Registrado por',
    'advertencias.selecionadas': '{{n}} de {{total}} marcadas',
    'advertencias.gerarDica': 'Vincula las ocurrencias seleccionadas a una gestión pendiente, con código único e historial.',
    'advertencias.detalhe.jornada': 'jornada de {{jornada}}',
    'advertencias.detalhe.limite': 'límite de {{limite}}',
    'advertencias.detalhe.lancado': 'registrado {{status}}',
    'advertencias.detalhe.previsto': 'apurado {{previsao}}',
    'advertencias.detalhe.km': '{{km}} entre apertura y cierre',
    'advertencias.detalhe.antecedencia': '{{tempo}} antes del horario programado',
    'advertencias.detalhe.kmAteProgramado': '{{km}} recorridos hasta el horario programado',
    'advertencias.detalhe.tpi': 'TPI {{tempo}}',
    'advertencias.detalhe.tpf': 'TPF {{tempo}}',
    'advertencias.detalhe.semRastreador': 'sin garantía del rastreador',
    'advertencias.filtro.ocorrencia': 'Ocurrencia',
    'advertencias.filtro.funcao': 'Función',
    'advertencias.col.inicio': 'Fecha y hora de inicio',
    'advertencias.col.fim': 'Fecha y hora de fin',
    'advertencias.col.tempoTotal': 'Tiempo total de la jornada',
    'advertencias.col.horasIndevidas': 'Horas Indebidas',
    'advertencias.horasIndevidas.incluir': 'Agregar a Horas Indebidas',
    'advertencias.horasIndevidas.adicionada': 'Agregada',
    'advertencias.horasIndevidas.adicionadaPor': 'Agregada a Horas Indebidas por {{quem}} el {{quando}}',
    'advertencias.horasIndevidas.automatica': 'Ya está en Horas Indebidas',
    'advertencias.horasIndevidas.semJornada': 'Sin inicio y fin de jornada no hay marcación que cambiar',
  },
}
